import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledStickySponsoredPopup = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  z-index: 1;
  &[data-align-left='true'] {
    left: 190px;
  }
  width: 350px;
  padding: 1rem 1.5rem 1rem 1rem;
  border: 1px solid ${theme.colors.neutral100};
  background: white;
  border-radius: 8px;
  box-shadow: 0px 0px 1px 0px #0000000a, 0px 0px 2px 0px #0000000f,
    0px 4px 8px 0px #0000000a;

  transform: translateX(-50%);
  ${MediaQueries.mbDown} {
    width: calc(100% - 2rem);
  }
`
